import { BING_RESPONSE_CHARACTER_LIMIT } from '../../config';

/**
 * Function calculates if the number of characters in the response might exceed the Bing Translator character limit or not. If so,
 * the array of languages for which translation is requested is split into a array of array of languages. The size of the inner array
 * depends on the translation term and is the floor value of the Bing Character Limit divided by the number of characters in the term
 * to translate. This ensures that for a translation call, the response does not exceed the Bing Translator character limit.
 */
export const getChunkedLanguageGroupArray = (term: string, allTargetLanguages: string[]): Array<Array<string>> => {
  const termLength: number = term.length;
  const numberOfLanguagesToLoadInOneGo: number =
    termLength * allTargetLanguages.length >= BING_RESPONSE_CHARACTER_LIMIT
      ? Math.floor(BING_RESPONSE_CHARACTER_LIMIT / termLength)
      : allTargetLanguages.length;
  let targetLanguagesArray: Array<Array<string>> = [];
  if (numberOfLanguagesToLoadInOneGo < allTargetLanguages.length) {
    while (allTargetLanguages.length) {
      targetLanguagesArray.push(allTargetLanguages.splice(0, numberOfLanguagesToLoadInOneGo));
    }
  } else {
    targetLanguagesArray = [allTargetLanguages];
  }
  return targetLanguagesArray;
};
